import React, { useState } from 'react';
import clsx from 'clsx';
import css from './Step.module.css';
import { StepLabel, StepState, StepVisual } from '../../step';
import { ProgressStep } from '../../progressStep';

export interface StepProps {
  step: ProgressStep;
  stepState: StepState;
  onCompletedStepClicked: () => void;
}

const Step: React.FC<StepProps> = (props: StepProps) => {
  const [isHover, setIsHover] = useState<boolean>(false);

  const startHover = () => {
    if (props.stepState === StepState.Complete) {
      setIsHover(true);
    }
  };
  const endHover = () => {
    setIsHover(false);
  };

  const onClick = () => {
    if (props.stepState === StepState.Complete) {
      props.onCompletedStepClicked();
    }
  };

  return (
    <div className={css.stepWrapper}>
      <div className={clsx(isHover ? css.stepVisualHover : null)}>
        <StepVisual
          stepState={props.stepState}
          onMouseEnter={startHover}
          onMouseLeave={endHover}
          onClick={onClick}
        />
      </div>
      <div
        className={clsx(
          css.stepLabelContainer,
          isHover ? css.stepLabelHover : null
        )}
      >
        <StepLabel
          label={props.step.name}
          stepState={props.stepState}
          onMouseEnter={startHover}
          onMouseLeave={endHover}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

export default Step;
